const maxSignedInt32 = 2147483647

/**
 * Set timeout with safe check
 * @param callback callback function
 * @param delay delay in milliseconds
 * @returns timeout id
 */
export function safeSetTimeout(
  callback: () => void,
  delay: number,
): NodeJS.Timeout | undefined {
  if (delay >= maxSignedInt32) {
    console.warn('Delay exceeds maximum value for setTimeout')
    return
  }

  return setTimeout(callback, delay)
}
